import { combineReducers } from 'redux';

import auth from './auth';
import account from './account';
import deviceStatus from './deviceStatus';
import userMessages from './userMessages';
import swaps from './swaps';
import hic from './hic';
import swapEligibility from './swapEligibility';
import returns from './returns';
import devices from './devices';
import order from './order';
import label from './label';
import session from './session';
import consolidatedOutage from './consolidatedOutage';
import itgRecommendations from './itgRecommendations';
import outage from './outage';
import nba from './nba';
import sik from './sik';
import cmsSupport from './cmsSupport';
import usage from './usage';
import internetPlan from './internetPlan';

const rootReducer = combineReducers({
  auth,
  account,
  deviceStatus,
  userMessages,
  swaps,
  hic,
  swapEligibility,
  returns,
  devices,
  order,
  label,
  session,
  consolidatedOutage,
  itgRecommendations,
  nba,
  sik,
  cmsSupport,
  outage,
  usage,
  internetPlan,
});

export default rootReducer;
